import {
  submitEnquiryFormPayload,
  submitEnquiryRes,
} from "@/store/types/enquiryForm";
import { sendCustomGaEvent } from "@/scripts/ga";
import { buildAnalyticsFormDataProps } from "@/utils/analyticsFormData";
import axiosInstance from "@/utils/axiosInstance";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const submitEnquiryForm = createAsyncThunk<
  submitEnquiryRes,
  submitEnquiryFormPayload
>("enquiry-form", async (payload, { rejectWithValue }) => {
  try {
    const { analyticsFormName, ...requestPayload } = payload;
    const analyticsPayload = {
      form_name: analyticsFormName || "enquiry_form",
      platform: payload.platform || "website",
      country_id: payload.countryId,
      city: payload.city,
      highest_qualification: payload.highestQualification,
      interested_countries_count: payload.interestedCountries?.length,
      has_email: Boolean(payload.email),
      ...buildAnalyticsFormDataProps({
        full_name: payload.fullName,
        phone_number: payload.phoneNumber,
        email: payload.email,
        city: payload.city,
        highest_qualification: payload.highestQualification,
        message: payload.message,
        interested_countries: payload.interestedCountries,
        platform: payload.platform,
        country_id: payload.countryId,
      }),
    };

    await sendCustomGaEvent(
      "enquiry_form_submit_attempt",
      analyticsPayload,
    );

    const { data } = await axiosInstance.post(`/enquiry-form`, requestPayload);

    await sendCustomGaEvent("enquiry_form_submit_success", {
      ...analyticsPayload,
      response_status: data.status,
      has_enquiry_id: Boolean(data.enquiryId),
    });

    return {
      status: data.status,
      enquiryId: data.enquiryId,
      message: data.message,
    };
  } catch (e) {
    const error =
      e && typeof e === "object" && "response" in e
        ? String(
            (
              e as {
                response?: { data?: { message?: string } };
                message?: string;
              }
            ).response?.data?.message ||
              (e as { message?: string }).message ||
              "unknown_error",
          )
        : e && typeof e === "object" && "message" in e
          ? String((e as { message?: string }).message || "unknown_error")
        : "unknown_error";

    await sendCustomGaEvent("enquiry_form_submit_failed", {
      form_name: payload.analyticsFormName || "enquiry_form",
      platform: payload.platform || "website",
      country_id: payload.countryId,
      city: payload.city,
      highest_qualification: payload.highestQualification,
      interested_countries_count: payload.interestedCountries?.length,
      has_email: Boolean(payload.email),
      ...buildAnalyticsFormDataProps({
        full_name: payload.fullName,
        phone_number: payload.phoneNumber,
        email: payload.email,
        city: payload.city,
        highest_qualification: payload.highestQualification,
        message: payload.message,
        interested_countries: payload.interestedCountries,
        platform: payload.platform,
        country_id: payload.countryId,
      }),
      error_message: error,
    });

    return rejectWithValue(e);
  }
});
